import type { JobItemResultVisibleJob } from '../../helpers';

export type ItemWithBanners =
  | JobItemResultVisibleJob
  | 'ProJobsUpsellBanner'
  | 'AISearchFeedbackBanner'
  | 'Ad';
type GetItemBannerProps = {
  showProJobsUpsellBanner?: boolean;
  showFeedbackBanner?: boolean;
  isMREnabled?: boolean;
};

export const getItemsWithBanner = (
  jobs: JobItemResultVisibleJob[],
  {
    showProJobsUpsellBanner,
    showFeedbackBanner,
    isMREnabled,
  }: GetItemBannerProps = {}
): ItemWithBanners[] => {
  if (isMREnabled) {
    const proJobsBannerIndex = 2;
    const aiFeedbackBannerIndex = proJobsBannerIndex + 1;
    const adIndex = aiFeedbackBannerIndex + 1;

    const firstPart = jobs.slice(0, proJobsBannerIndex);
    const secondPart = jobs.slice(proJobsBannerIndex, aiFeedbackBannerIndex);
    const thirdPart = jobs.slice(aiFeedbackBannerIndex, adIndex);
    const lastPart = jobs.slice(adIndex);

    const projobsBanner = showProJobsUpsellBanner
      ? ['ProJobsUpsellBanner' as const]
      : [];
    const ad = ['Ad' as const];
    const aiFeedbackBanner = ['AISearchFeedbackBanner' as const];

    return [
      ...firstPart,
      ...projobsBanner,
      ...secondPart,
      ...aiFeedbackBanner,
      ...thirdPart,
      ...ad,
      ...lastPart,
    ];
  }

  const proJobsBannerIndex = 2;
  const adIndex = showProJobsUpsellBanner ? 4 : 5;
  const aiFeedbackBannerIndex = adIndex + 1;

  const firstPart = jobs.slice(0, proJobsBannerIndex);
  const secondPart = jobs.slice(proJobsBannerIndex, adIndex);
  const thirdPart = jobs.slice(adIndex, aiFeedbackBannerIndex);
  const lastPart = jobs.slice(aiFeedbackBannerIndex);

  const projobsBanner = showProJobsUpsellBanner
    ? ['ProJobsUpsellBanner' as const]
    : [];
  const ad = ['Ad' as const];
  const aiFeedbackBanner = showFeedbackBanner
    ? ['AISearchFeedbackBanner' as const]
    : [];

  return [
    ...firstPart,
    ...projobsBanner,
    ...secondPart,
    ...ad,
    ...thirdPart,
    ...aiFeedbackBanner,
    ...lastPart,
  ];
};
